// src/lib/gradient.js — gradient determinístico por id ou nome.
// Portado verbatim do monolítico (~linha 11257).
// Mesmo input sempre gera mesmo gradient → avatares de obras/clientes ficam estáveis.

import { initials } from './dom.js';

const PALETTES = [
  ['#7C5CFC', '#FB923C'],
  ['var(--sc-info)', '#EC4899'],
  ['#EC4899', '#FACC15'],
  ['#FB923C', 'var(--sc-info)'],
  ['#FACC15', '#EC4899'],
  ['#7C5CFC', 'var(--sc-info)'],
  ['#6D28D9', '#7C5CFC'],
  ['#EC4899', '#FB923C'],
  ['#FACC15', 'var(--sc-info)'],
];

function _hash(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0; // converte para int32
  }
  return Math.abs(h);
}

/**
 * Retorna 'linear-gradient(135deg, X, Y)' determinístico.
 * @param {string} idOrName — UUID, slug, nome — qualquer string
 */
export function gradientForId(idOrName) {
  const idx = _hash(idOrName || '') % PALETTES.length;
  const [c1, c2] = PALETTES[idx];
  return `linear-gradient(135deg, ${c1}, ${c2})`;
}

/**
 * HTML de avatar (gradient + iniciais) — variante do _favObra do monolítico.
 * @param {string} nome
 * @param {string} id
 * @param {number} [size=32]
 */
export function avatar(nome, id, size = 32) {
  return `<span class="avatar-grad" style="
    display:inline-flex; align-items:center; justify-content:center;
    width:${size}px; height:${size}px; border-radius:50%;
    background:${gradientForId(id || nome || '')};
    color:#fff; font-weight:600; font-size:${Math.floor(size * 0.42)}px;
    letter-spacing:-0.02em; flex-shrink:0;
  ">${initials(nome)}</span>`;
}
